import TopNav from '@components/Nav/TopNav';
import TipDirectLeftMenu from '@components/Nav/TopNav/TipDirectLeftMenu';
import { StyleBreakpoints } from '@constants';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { connect } from 'react-redux';
import Payouts from './StripeConnectPortal/Payouts';
import StripeVerificationWarning from '@components/StripeVerificationWarning';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',

    [theme.breakpoints.up(StyleBreakpoints.sm)]: {
      flexDirection: 'row'
    }
  },
}));

const Balance = ({ user }) => {
  const classes = useStyles();
  const urlParams = new URLSearchParams(window.location.search);
  const isHistoric = urlParams.get('historic') === 'true';

  return (
    <>
      <TopNav />
      <div className={classes.container}>
        <TipDirectLeftMenu selectedTab={'Balance'} />
        <div className="flex-1 flex flex-col items-center px-4 py-6 md:px-8 w-full max-w-7xl mx-auto min-w-0">
          {isHistoric && (
            <div className="w-full max-w-[600px] flex flex-col bg-amber-50 border border-solid border-amber-200 text-amber-700 p-4 rounded-xl shadow-sm my-4">
              <div className="font-bold text-base mb-1">Viewing Historic Balance</div>
              <div className="text-sm leading-relaxed">
                You are currently viewing and interacting with your previous Stripe US account. Any payouts or settings configured here apply only to your historical balance.
              </div>
            </div>
          )}
          {!isHistoric && <StripeVerificationWarning user={user} />}
          <Payouts key={isHistoric ? 'historic' : 'current'} user={user} historic={isHistoric} />
        </div>
      </div>
    </>
  );
};

const mapStateToProps = state => ({
  user: state.user?.user
});

export default connect(mapStateToProps)(Balance);
